import header from "./marketing-fuer-laptop-und-handy.jpg";
import section1 from "./fotos-fuer-immobilienmarketing.webp";
import section2 from "./arbeiten-am-laptop.jpg";
import section3 from "./grundriss-auf-tablet.jpg";
import section4 from "./grundrisse-fuer-immobilienmarketing.jpg";
import section5 from "./beispiel-grundriss-auf-tablet.webp";
import section6 from "./grundriss-auf-pc.jpg";
import section7 from "./grundriss-mit-icons.webp";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
